import React, { useContext } from 'react';
import { useWindowSize } from 'react-use';
import { config } from 'config';
import { CleanKwh } from 'contexts/clean-kwh';
import { ErrorModule } from 'components/errors';
import { LoadingModule } from 'components/loading';
import { Desktop } from './desktop';
import { Mobile } from './mobile';

const { breakpoints } = config.theme.media;

export const UsageSummary = () => {
  const { loading, error } = useContext(CleanKwh);
  const { width } = useWindowSize();

  if (loading) return <LoadingModule />;
  if (error) return <ErrorModule />;

  return width > breakpoints.small ? <Desktop /> : <Mobile />;
};
